import { invoicesCredits } from './invoices-credits-de.i18n';

export const de = {
  invoicesCredits,
};
